import React, { useState, useEffect, useRef } from 'react';
import './PlayOffDownDetails.css';

import AnimateHeight from 'react-animate-height';

import axios from "axios";
import Partie from '../Partie';
import { getCorrectListClub } from '../../variables';
import CartridgePlayers from '../CartridgePlayers';
import io from 'socket.io-client';

var XMLParser = require('react-xml-parser');

function getWindowSize() {
    const {innerWidth, innerHeight} = window;
    return {innerWidth, innerHeight};
}

const PlayOffDownDetails = ({
    rencId,
    homeClub,
    awayClub,
    deploy,
    headerLivescore,
    division,
    match,
    showDetails
}) => {
    const [socket, setSocket] = useState(null);
    const [details, setDetails] = useState([]);

    const [livescore, setLivescore] = useState([]);
    const [jsonMatch, setJsonMatch] = useState(null);

    const livescoreRef = useRef(livescore);
    const jsonMatchRef = useRef(jsonMatch);

    const [isOnLive, setIsOnLive] = useState(false);
    const [liveTeamA, setLiveTeamA] = useState([]);
    const [liveTeamX, setLiveTeamX] = useState([]);

    useEffect(() => {
        if (deploy === rencId) {
            if (headerLivescore.status !== "en_cours") {
                getDetailsMatch();
            }
        }

        if (details.length == 0) {
            getDetailsMatch();
            // RAJOUTER UNE CONDITION POUR SAVOIR SI IL Y A DES DETAILS
            // SI CEST LE CAS ALORS ON NE RECUPERE PAS LES MATCHS DU LIVESCORING
            if (headerLivescore.status === "termine") {
                getDetailsDafunker();
            }
        }

        // on ne veut pas que la connexion socket soit établit si le match est fermé
        if (!showDetails) {
            // si livescoring
            if (headerLivescore.status == 'en_cours' && socket !== null) {
                // on désactive le socket si on n'a pas déroulé le match
                socket.disconnect();
                setSocket(null);
                setIsOnLive(false);
                return;
            }
        }

        // on initialise le socket pour les matchs déroulés d'aujourd'hui 
        if (headerLivescore.status == 'en_cours') {
            const link = "https://fftt.dafunker.com:3000/livescore_" + rencId + "?" + getCData();
            const tmpSocket = io(link);

            // Message de connexion
            tmpSocket.on('connect', () => {
            });
    

            // Ecouter les messages d'update de l'entete du match
            tmpSocket.on('update', (jsonSocket) => {
                setIsOnLive(true);
                parseLivescoreForPartie(jsonSocket);
                jsonMatchRef.current = jsonSocket;
                setJsonMatch(jsonSocket);
            });

            // Ecouter les messages d'update du match
            tmpSocket.on('update_partie', (jsonPartie) => {
                setIsOnLive(true);
                mergeJsonPartieWithLivescore(jsonPartie);
            });

    
            // on sauvegarde le socket
            setSocket(tmpSocket);
    
            // Nettoyage de l'effet lors du démontage du composant
            return () => {
                setIsOnLive(false);
                tmpSocket.disconnect();
            };
        }

    }, [showDetails])

    const getDetailsMatch = async () => {
        try {
            const url = `https://apiv2.fftt.com/mobile/pxml/xml_chp_renc.php?id=SW001&tm=20210925115025407&tmc=b69782b1b8e550626506d025fe4824b7db6859b7&renc_id=${rencId}`;
            const response = axios.get(url, {
                "Content-Type": "application/xml; charset=utf-8"
            })
            .then((res) => {
                const data = new XMLParser().parseFromString(res.data).children;

                // on vérifie que le match ait bien des parties jouées
                const partie = data.find(item => item.name === "partie");
                if (partie !== null && partie !== undefined) {
                    if (partie.children.length > 0) {
                        setDetails(parseXMLtoJSON(data));
                        return;
                    }
                }
            })
        }
        catch (error) {
            console.log(error);
        }
    }

    const getDetailsDafunker = async () => {
        const link = "https://fftt.dafunker.com/livescore/get/" + rencId;
        axios
        .get(link, {
            "Content-Type": "application/xml; charset=utf-8"
        })
        .then(function(res) {
            const data = res.data;
            parseLivescoreForPartie(data);
        })
        .catch(function(error) {
            console.log(error);
        });
    }

    const getCData = () => {
        const link = "renc_id=" + rencId
        + "&is_retour=0" 
        + "&phase=2" 
        + "&res_1=0" 
        + "&res_2=0" 
        + "&equip_1=" + match.domicile.replaceAll(" ","+") 
        + "&equip_2=" +match.exterieur.replaceAll(" ","+")
        + "&equip_id1=00000"
        + "&equip_id2=00000" 
        + "&clubnum_1=" + match.clubnum_1  
        + "&clubnum_2=" + match.clubnum_2;
        return link;
    }

    const parseXMLtoJSON = (xmlMatch) => {
        const parties = [];
        const teamA = [];
        const teamX = [];
        xmlMatch.forEach((item) => {
            if (item.name === 'partie') {
                let object = {};
                item.children.forEach((child) => {
                    // on adapte le score pour correspondre au format livescore
                    // 09 -05 07 -09 06 ->>>> [[11, 9], [5, 11], [11, 7], [9, 11], [11, 6]]
                    if (child.name === "detail") {
                        // notre array qui contient le score
                        const sets = [];
                        // on split le string pour récupérer chaque set
                        const scores = child.value.split(' ');
                        // on insère chaque set dans un array pour correspondre au bon format
                        scores.forEach((score) => {
                            const scoreBrut = parseInt(score.replace('-', ''));
                            let scoreJA = 0; let scoreJB = 0;

                            // défaite du joueur A
                            if (score.includes('-')) {
                                scoreJA = parseInt(scoreBrut);
                                scoreJB = parseInt(scoreBrut >= 10 ? scoreBrut + 2 : 11);
                            }
                            // victoire du joueur A
                            else {
                                scoreJA = parseInt(scoreBrut >= 10 ? scoreBrut + 2 : 11);
                                scoreJB = parseInt(scoreBrut);
                            }

                            // à noter que le parseInt retire le 0 devant le score
                            // utile pour récupérer le score directement 

                            // on insère les scores dans notre array
                            sets.push([scoreJA, scoreJB]);
                        });
                        object[child.name] = sets;
                    }
                    else {
                        object[child.name] = child.value;
                    }
                })
                // on insère la partie
                parties.push(object);
            }
            else if(item.name === 'joueur')
            {
                teamA.push(item.children[0].value + " " + item.children[1].value);
                teamX.push(item.children[2].value + " " + item.children[3].value);
            }
        })
        setLiveTeamA(teamA);
        setLiveTeamX(teamX);
        return parties;
    }

    const CalSetA = (score) =>  {
        let total = 0;
        score.forEach((game) => {
           
            if(game[0] > game[1])
            {
                total = total + 1;
            }
        })
        return total;
    }

    const CalSetX = (score) =>  {
        let total = 0;
        score.forEach((game) => {
           
            if(game[0] < game[1])
            {
                total = total + 1;
            }
        })
        return total;
    }

    const parseLivescoreForPartie = (match) => {
        const parties = [];
        match.parties.forEach((partie) => {

             // on récupère le slotID des joueurs
            const slotIdJA = partie.joueur1.slotId;
            const slotIdJB = partie.joueur2.slotId;
            let fullNameJA = ""; let fullNameJB = "";

            if (slotIdJA !== "") {
                fullNameJA = match.equipe1.joueurs[slotIdJA].nom + " " + match.equipe1.joueurs[slotIdJA].prenom;
            }

            if (slotIdJB !== "") {
                fullNameJB = match.equipe2.joueurs[slotIdJB].nom + " " + match.equipe2.joueurs[slotIdJB].prenom;
            }
            
            // Ne pas prendre en compte les matchs sans joueurs définis pour l'afficher
            if(fullNameJA != "" && fullNameJB != "")
            {
                parties.push({
                    "id": partie.id,
                    "ja": fullNameJA,
                    "jb": fullNameJB,
                    "scorea": '' + CalSetA(partie.score),
                    "scoreb": '' + CalSetX(partie.score),
                    "detail": partie.score,
                    "premier_serveur": partie.premier_serveur,
                });
            }   
        })
        livescoreRef.current = parties;
        setLivescore(parties);

        const joueursA = [];
        joueursA.push(match?.equipe1?.joueurs?.JA1);
        joueursA.push(match?.equipe1?.joueurs?.JA2);
        joueursA.push(match?.equipe1?.joueurs?.JA3);
        joueursA.push(match?.equipe1?.joueurs?.JA4);
        setLiveTeamA(joueursA);

        const joueursX = [];
        joueursX.push(match?.equipe2.joueurs?.JB1);
        joueursX.push(match?.equipe2.joueurs?.JB2);
        joueursX.push(match?.equipe2.joueurs?.JB3);
        joueursX.push(match?.equipe2.joueurs?.JB4);
        setLiveTeamX(joueursX);
    }

    const mergeJsonPartieWithLivescore = (partieToMerge) => {
        let livescorePartie = livescoreRef.current.findIndex(partie => partie.id === partieToMerge.id);
        let tmpLivescore = [...livescoreRef.current];
        // on regarde si le match a été supprimé
        if (partieToMerge.status === "deleted") {
            // si on avait le match alors on supprime
            if (livescorePartie !== -1) {
                tmpLivescore = tmpLivescore.filter(partie => partie.id !== partieToMerge.id);
                livescoreRef.current = tmpLivescore;
                setLivescore(tmpLivescore)
            }
            return;
        }

        // on récupère le slotID des joueurs
        const slotIdJA = partieToMerge.joueur1.slotId;
        const slotIdJB = partieToMerge.joueur2.slotId;
        let fullNameJA = ""; let fullNameJB = "";

        if (slotIdJA !== "") {
            fullNameJA = jsonMatchRef.current.equipe1.joueurs[slotIdJA].nom + " " + jsonMatchRef.current.equipe1.joueurs[slotIdJA].prenom;
        }

        if (slotIdJB !== "") {
            fullNameJB = jsonMatchRef.current.equipe2.joueurs[slotIdJB].nom + " " + jsonMatchRef.current.equipe2.joueurs[slotIdJB].prenom;
        }

        const data = {
            "id": partieToMerge.id,
            "ja": fullNameJA,
            "jb": fullNameJB,
            "scorea": '' + CalSetA(partieToMerge.score),
            "scoreb": '' + CalSetX(partieToMerge.score),
            "detail": partieToMerge.score,
            "premier_serveur": partieToMerge.premier_serveur,
        };

        // on update/insert
        if (livescorePartie !== -1) {
            tmpLivescore[livescorePartie] = data
        }
        else {
            tmpLivescore.push(data);
        }
        

        // on met à jour les matchs
        livescoreRef.current = tmpLivescore;
        setLivescore(tmpLivescore)
    }

    const isTerminate = () => {
        return headerLivescore.status === "termine" && details.length < 1;
    }

    const getTotalPartie = () => {
        let count = 0;
        if (headerLivescore.status === "en_cours" || isTerminate())
        {
            count = livescore.length;
        }

        details?.forEach((detail) => {
            if (detail?.scorea !== "-" || detail?.scoreb !== "-") {
                count++;
            }
        });
        return count;
    }

    if (getTotalPartie() === 0) return;

    return ( 
        <AnimateHeight 
            key={rencId} 
            id={rencId}
            duration={500}
            height={showDetails ? 'auto' : 0}
        >
            <div className='playoffdown_details_component'>

                {(isOnLive == true) &&(
                    <h1 style={{color: 'red'}}>En direct</h1>   
                )
                
                || (
                    <h1>{getTotalPartie()} partie(s) disputé(es)</h1>
                )}

                {/* Affichage du cartouche des joueurs */                        
                (headerLivescore.status === "en_cours" || isTerminate()) &&
                    <CartridgePlayers id={rencId} liveTeamA={liveTeamA} liveTeamX={liveTeamX} isFromSPID={false}></CartridgePlayers>  
                ||
                    <CartridgePlayers id={rencId} liveTeamA={liveTeamA} liveTeamX={liveTeamX} isFromSPID={true}></CartridgePlayers>  
                } 
                {/* Affichage du détail des matchs */}
                <div style={{maxWidth: getWindowSize().innerWidth > 1000 ? 450 : 300}}>
                    {
                        (headerLivescore.status === "en_cours" || isTerminate()) &&
                        livescore?.map((detail, index) => {
                            return (
                                (detail.scorea !== "-" || detail.scoreb !== "-") &&
                                <div
                                    key={index} 
                                    style={{marginBottom: 20}}
                                >
                                    <Partie status={headerLivescore.status} match={detail} teamJA={homeClub} teamJB={awayClub} isLivescoring />
                                </div>
                            )
                        })
                        ||
                        details?.map((detail, index) => {
                            return (
                                (detail.scorea !== "-" || detail.scoreb !== "-") &&
                                <div
                                    key={index} 
                                    style={{marginBottom: 20}}
                                >
                                    <Partie status={headerLivescore.status} match={detail} teamJA={homeClub} teamJB={awayClub} isOffDown/>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </AnimateHeight>
    );
}
 
export default PlayOffDownDetails;